import { useForm } from 'react-hook-form';
import { FormProvider, TextField } from '../../../../../components';
import { Typography, Stack, Button } from '@mui/material';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export const LisTestItemMasterHelpForm = ({ onClose, onAdd }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        // help_descript: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;

  const formSubmitHandler = (formValues) => {
    onAdd({ ...formValues, _id: Date.now().toString() });
    reset();
    console.log('Form Values:', formValues);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmitHandler)}>
      <Stack sx={{ p: 1.5, minWidth: '35rem' }} spacing={2}>
        <Stack spacing={0.5} direction="row" alignItems="center">
          <Typography sx={{ flex: 0.3, fontWeight: 700 }}>Help Descript</Typography>
          <TextField sx={{ flex: 1 }} name="help_descript" />
        </Stack>
        <Stack sx={{ flex: 1 }} spacing={0.5} direction="row" alignItems="center" justifyContent="end">
          <Button size="small" color="error" onClick={onClose}>
            Cancel
          </Button>
          <Button size="small" variant="contained" type="submit">
            Add
          </Button>
        </Stack>
      </Stack>
    </FormProvider>
  );
};
